<div mat-dialog-title>Initialize Tracker</div>
<div mat-dialog-content>
  <p>
    This will initialize the Document Tracker with files for the tax season of
    the year provided below:
  </p>
  <mat-form-field>
    <input matInput [(ngModel)]="date" required placeholder="Year" />
    <mat-hint>YYYY</mat-hint>
  </mat-form-field>
  @if (lastRun) {
    <div>
      This process was last run by {{ lastRun.user?.person?.name ?? 'System' }} on {{lastRun.created | date: 'MM/dd/yyyy'}}
    </div>
  }
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="dialogRef.close()">Cancel</button>
  <button
    mat-raised-button
    [disabled]="date?.length !== 4"
    color="primary"
    (click)="initialize()">
    Initialize
  </button>
</div>
